export const flattenObject = (object) => {
  return Object.keys(object).reduce((acc, key) => {
    const newPath = [key].filter(Boolean).toString();
    return typeof object?.[key] === "object" ? { ...acc, ...flattenObject(object[key]) } : { ...acc, [newPath]: object[key] };
  }, {});
};
